import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

import { PillsService, SessionStorageService, SidebarStorageService, ActivityReportsService, InvoicesService } from '@shared/services';
import { ToggleSidebarDirective } from '@shared/directives';

@Component({
  selector: 'mobile-header-menu',
  templateUrl: 'mobile-header-menu.component.html',
  styleUrls: ['./mobile-header-menu.component.sass'],
  host: { 'class': 'am-flex-justify am-flex-align mt-s mb-s relative' },
  viewProviders: [ToggleSidebarDirective],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class MobileHeaderMenuComponent implements OnInit {
  backCallback: Function;
  actives: number[] = [];
  constructor(
    private router:                 Router,
    private sessionStorageService:  SessionStorageService,
    private sidebarStorageService:  SidebarStorageService,
    private activityReportsService: ActivityReportsService,
    private invoicesService:        InvoicesService,
    private pillsService:           PillsService
  ) { }

  ngOnInit(): void {
    this.sessionStorageService.mobileGoBackFunc.subscribe(callback => this.backCallback = callback);
    this.pillsService.actives.subscribe(actives => {
      this.actives = actives
    })
  }

  backCallbackHandler(): void {
    this.backCallback();
  }

  openHomePage(): void {
    this.sessionStorageService.changeAndResetActiveTab('dashboard');
    let navItem = this.sidebarStorageService.sidebarItems.find(item => item.identifier === 'dashboard');
    this.router.navigateByUrl(`${this.sessionStorageService.activeAppValue}/${navItem.path}`);

    if      (this.sessionStorageService.isTimeTracking) this.activityReportsService.forceReload();
    else if (this.sessionStorageService.isInvoices)     this.invoicesService.forceReload(navItem.filter);
  }

  openApplicationSwitcher(): void {
    this.sessionStorageService.pushDynamicComponent({
      component: 'ApplicationSwitcherMobile'
    });
  }

  opePillPicker(): void {
    this.pillsService.openPicker();
  }

}
